/* eslint-disable functional/no-conditional-statement */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect } from "react";
import { useLocation } from "../../common/hooks/useLocation";
import { languageFromNavigator } from "../miscellaneous/languageFromNavigator";
import { replaceHtmlElementById } from "../miscellaneous/replaceHtmlElementById";
import { checkShowHeaderFullContent } from "../miscellaneous/checkShowHeaderFullContent";
import { UseSettingsValueData } from "./useSettingsValueData";

export function useSetHtmlFromSettings(settings: UseSettingsValueData) {
  const { pathname } = useLocation();
  const language = languageFromNavigator();

  useEffect(() => {
    if (settings.tag === "ready") {
      checkShowHeaderFullContent(pathname);

      const replaceAttributeOnly = "replace-attribute-only";
      const logoUrl = settings.data.logoUrl;

      const partnerName = settings.data.partnerName ?? "PARTNER NAME";
      const pageIntegration = settings.data.pageIntegration;

      const homepageUrl = pageIntegration?.partnerLinks?.homePageUrl as string;
      const productsPageUrl = pageIntegration?.partnerLinks
        ?.productsPageUrl as string;

      if (!!logoUrl) {
        replaceHtmlElementById(
          "partner-logo",
          { src: logoUrl, alt: `${partnerName} Logo` },
          replaceAttributeOnly
        );
      }
      if (!!homepageUrl) {
        replaceHtmlElementById(
          "partner-public-url",
          { href: homepageUrl },
          replaceAttributeOnly
        );
      }
      if (!!productsPageUrl) {
        replaceHtmlElementById(
          "partner-products-url",
          { href: productsPageUrl },
          replaceAttributeOnly
        );
      }
    }
  }, [settings.data, pathname, language]);
}
